// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { uuid } from './lib/funcs'
import Vue from 'vue'
import App from './App'
import DummyGNav from './components/DummyGNav'
import router from './router'

Vue.config.productionTip = false

Vue.mixin( {
  data () {
    return { uuid: uuid() }
  },
  methods: {
    log ( msg ) {
      console.log( msg )
    }
  }
} )

/* eslint-disable no-new */

new Vue( {
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
} )

if ( process.env.NODE_ENV === 'development' ) {
  let el = document.createElement( 'div' )
  let app = document.getElementById( 'app' )
  let gnavJs = document.createElement( 'script' )
  let gnavCss = document.createElement( 'link' )

  el.classList.add( 'Gnav-active' )
  gnavJs.type = 'text/javascript'
  gnavJs.src = '//wwwimages2.adobe.com/etc/beagle/public/globalnav/adobe-globalnav/latest/adobe-globalnav.min.js'
  gnavCss.rel = 'stylesheet'
  gnavCss.href = 'https://wwwimages2.adobe.com/etc/beagle/public/globalnav/adobe-globalnav/latest/adobe-globalnav.min.css'

  document.body.appendChild( gnavJs )
  document.getElementsByTagName( 'head' )[ 0 ].appendChild( gnavCss )
  document.body.insertBefore( el, app )

  new Vue( {
    el: el,
    template: '<DummyGNav/>',
    components: { DummyGNav }
  } )
}



// WEBPACK FOOTER //
// ./src/main.js